export default "assets/images/icons/twitter-1a07453e.svg";